export default "/static/webpack/media/undraw_resume_folder.517255af.svg";